import { v4 as uuidv4 } from 'uuid';
import type { Ref } from 'vue';
import { ref } from 'vue';

export interface ToastInterface {
  'resolve': CallableFunction;
  'reject': CallableFunction;
  [x: string]: any;
}

export interface ToastObjectInterface {
  'id': string;
  'toast': Record<string, CallableFunction>;
  'props'?: any;
}

export const toasts: Ref<Array<ToastObjectInterface>> = ref<Array<ToastObjectInterface>>([]);

function closeToast(id?: string): ToastObjectInterface | null {
  if (!id) {
    return toasts.value.pop() ?? null;
  }

  const idx = toasts.value.findIndex((item: ToastObjectInterface) => item.id == id);
  const toastsRemovedArray = toasts.value.splice(idx, 1);

  return toastsRemovedArray.length ? toastsRemovedArray[0] : null;
}

function modalEscapeHandler($event: KeyboardEvent) {
  if ($event.key !== 'Escape') {
    return;
  }
  const toastObj = closeToast();
  toastObj?.toast.reject();
}

export function displayToast(props?: any, options?: Record<string, any>): Promise<any> {
  const toastId = uuidv4();

  const propsObject = props ? props : {};
  // check and make sure components are attached to #app
  const modalOverlayElement = document.getElementById('modal-overlay');
  if (!modalOverlayElement) {
    throw new Error('must include overlay');
  }

  // handle closing modal on escape
  window.addEventListener('keyup', modalEscapeHandler);

  // create promise
  const modalPromise = new Promise((resolve, reject) => {
    const modalObject: ToastObjectInterface = {
      'id': toastId,
      'toast': { resolve, reject },
      'props': propsObject,
    };
    toasts.value.push(modalObject);
  });
  // When the modal resolves or rejects, close it.
  modalPromise.then(
    (results) => closeToast(toastId),
    (error) => closeToast(toastId),
  );

  // we return the bare promise, so it can handle any results directly, and we
  // don't need to raise from the hadler that closes the modal
  return modalPromise;
}
